var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"qrcode"},[(_vm.pdf)?[_c('div',{staticClass:"qrcode__qrcode"},[_c('qriously',{attrs:{"value":_vm.pdf,"size":_vm.qrcodeSize}})],1),_c('p',[_vm._v("この情報をダウンロードするにはこちら")])]:_c('p',[_vm._v("チラシがありません。削除された可能性があります")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }